import { radioAnatomy as parts } from '@chakra-ui/anatomy';
import type { PartsStyleObject } from '@chakra-ui/react';

const mbeVariant: PartsStyleObject<typeof parts> = {
  control: {
    borderColor: '#bfbfb0',
    _checked: {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      bg: 'brand.black',
      borderColor: '#bfbfb0',
      color: 'brand.black',
      _hover: {
        bg: 'brand.black',
        borderColor: '#bfbfb0',
      },
    },
  },
};

export default {
  parts: parts.keys,
  variants: {
    mbe: mbeVariant,
  },
};
